import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a759ca2c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a759ca2c')) {
      api.createRecord('a759ca2c', component.options)
    } else {
      api.reload('a759ca2c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a759ca2c", function () {
      api.rerender('a759ca2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/objectType/index.vue"
export default component.exports